// extracted by mini-css-extract-plugin
export default {"menuBlock":"FI-z","title":"GI-z","nav":"HI-z","flexCell":"II-z","facetLink":"JI-z"};